<puro-modal
  class="review-cancel-shipment-dialog__modal"
  [className]="'review-cancel-shipment-dialog__modal'"
  [open]="open()"
  [title]="modalTitle()"
  size="medium"
  [showCloseButton]="false"
  [closeOnBackdrop]="true"
  [actions]="actions()"
  (closeModal)="onDismiss()"
  data-testid="review-cancel-shipment-dialog"
>
  <puro-typography component="p" variant="body1" class="review-cancel-shipment-dialog__body">
    {{ 'createShipment.reviewAndPay.cancelShipment.body' | translate }}
  </puro-typography>
</puro-modal>
